// Email Validation for Gift Recipient & Additional Storyteller
// Supports both English (Legacy Book) and Spanish (Libro de Memorias) products.
document.addEventListener("DOMContentLoaded", function () {
  function log(...args) {
    console.log("CUSTOM EMAIL VALIDATION -", ...args);
  }

  log("init");

  // Detect language based on which radio group is present
  const EN_RADIO_NAME = 'properties[Who will be telling stories?]';
  const ES_RADIO_NAME = 'properties[¿Quién contará las historias?]';

  let lang = null;
  if (document.querySelector('input[name="' + EN_RADIO_NAME + '"]')) {
    lang = "en";
  } else if (document.querySelector('input[name="' + ES_RADIO_NAME + '"]')) {
    lang = "es";
  } else {
    log("Not Legacy Book / Libro de Memorias product, skipping validation");
    return;
  }
  log("Detected language:", lang);

  const STRINGS = {
    en: {
      radioName: EN_RADIO_NAME,
      selectWho: "Please select who will be telling stories",
      giftNameReq: "Gift recipient name is required",
      giftEmailReq: "Gift recipient email is required",
      giftEmailBad: "Please enter a valid email address for the gift recipient",
      giftDateReq: "Gift date is required",
      giftPhoneReq: "Gift recipient phone number is required",
      giftPhoneBad: "Please enter a valid phone number for the gift recipient",
      selfPhoneReq: "Your phone number is required",
      selfPhoneBad: "Please enter a valid phone number",
      storytellerNameReq: "Storyteller name is required",
      storytellerEmailReq: "Storyteller email is required",
      storytellerEmailBad: "Please enter a valid email address for the storyteller",
      storytellerPhoneReq: "Storyteller phone number is required",
      storytellerPhoneBad: "Please enter a valid phone number for the storyteller",
      duplicateEmail: "Gift recipient email and storyteller email must be different",
      phoneOptionalPlaceholder: "Phone number (include country code)",
    },
    es: {
      radioName: ES_RADIO_NAME,
      selectWho: "Por favor selecciona quién contará las historias",
      giftNameReq: "El nombre de quien recibe el regalo es obligatorio",
      giftEmailReq: "El correo electrónico de quien recibe el regalo es obligatorio",
      giftEmailBad: "Por favor ingresa un correo electrónico válido para quien recibe el regalo",
      giftDateReq: "La fecha del regalo es obligatoria",
      giftPhoneReq: "El número de teléfono de quien recibe el regalo es obligatorio",
      giftPhoneBad: "Por favor ingresa un número de teléfono válido para quien recibe el regalo",
      selfPhoneReq: "Tu número de teléfono es obligatorio",
      selfPhoneBad: "Por favor ingresa un número de teléfono válido",
      storytellerNameReq: "El nombre del narrador es obligatorio",
      storytellerEmailReq: "El correo electrónico del narrador es obligatorio",
      storytellerEmailBad: "Por favor ingresa un correo electrónico válido para el narrador",
      storytellerPhoneReq: "El número de teléfono del narrador es obligatorio",
      storytellerPhoneBad: "Por favor ingresa un número de teléfono válido para el narrador",
      duplicateEmail: "El correo de quien recibe el regalo y el correo del narrador deben ser distintos",
      phoneOptionalPlaceholder: "Número de teléfono (incluye el código de país)",
    },
  };
  const S = STRINGS[lang];

  // Larry 2026-10-07: the phone number is only used to call the storyteller and get the
  // book started. US visitors keep the phone fields required (with the sanity check below).
  // Visitors shopping from any other country get NO phone validation and the phone fields
  // are optional, so an international customer is never stopped at Add to cart.
  // Country comes from Shopify Markets (the footer country selector): Shopify.country is
  // the ISO code of the active market context; fallback is the active currency (USD = US).
  // If neither is readable, the US rule applies.
  function visitorIsUS() {
    try {
      const shopify = window.Shopify || {};
      if (shopify.country) return String(shopify.country).toUpperCase() === "US";
      if (shopify.currency && shopify.currency.active) {
        return String(shopify.currency.active).toUpperCase() === "USD";
      }
    } catch (e) {}
    return true;
  }
  const PHONE_REQUIRED = visitorIsUS();
  log("Visitor country:", (window.Shopify || {}).country, "- phone required:", PHONE_REQUIRED);

  const emailRegex =
    /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i;

  // Gift recipient fields (from legacy-book-fields.liquid / legacy-book-fields-es.liquid)
  const giftNameInput = document.querySelector("#gift-recipient-name");
  const giftEmailInput = document.querySelector("#gift-recipient-email");
  const giftDateInput = document.querySelector("#gift-date");
  const giftPhoneInput = document.querySelector("#gift-recipient-phone");
  const selfPhoneInput = document.querySelector("#self-phone");

  // Storyteller fields (from main-product.liquid)
  const storytellerFieldsContainer = document.querySelector(".additional-storytellers-fields");

  // Non-US: show the phone fields as optional (drop the red asterisk and the US-style
  // "(555) 123-4567" placeholder). Nothing else on the page changes.
  function markPhoneOptional() {
    [giftPhoneInput, selfPhoneInput].forEach(function (input) {
      if (!input) return;
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.querySelectorAll(".required").forEach(function (star) { star.remove(); });
      }
      input.placeholder = S.phoneOptionalPlaceholder;
      input.setAttribute("aria-required", "false");
    });
  }
  if (!PHONE_REQUIRED) markPhoneOptional();

  if (storytellerFieldsContainer) {
    storytellerFieldsContainer.addEventListener("change", function (e) {
      e.stopPropagation();
    }, true);
  }

  function isSomeoneElseSelected() {
    const radio = document.querySelector("#who-telling-someone-else");
    return radio && radio.checked;
  }

  function isMyselfSelected() {
    const radio = document.querySelector("#who-telling-myself");
    return radio && radio.checked;
  }

  function getVisibleStoryteller() {
    if (!storytellerFieldsContainer || storytellerFieldsContainer.hidden) return null;
    const visible = storytellerFieldsContainer.querySelector('.storyteller-field:not([style*="display: none"])');
    if (!visible) return null;
    const nameInput = visible.querySelector('input[type="text"]');
    const emailInput = visible.querySelector('input[type="email"]');
    const phoneInput = visible.querySelector('input[type="tel"]');
    return { nameInput, emailInput, phoneInput };
  }

  function showError(message) {
    const errorDiv = document.createElement("div");
    errorDiv.className = "email-validation-error";
    errorDiv.style.cssText = "color:#d32f2f;font-size:14px;margin-bottom:10px;";
    errorDiv.textContent = message;
    const buttonsContainer = document.querySelector(".product-form__buttons");
    if (buttonsContainer) buttonsContainer.insertBefore(errorDiv, buttonsContainer.firstChild);
  }

  function removeErrors() {
    document.querySelectorAll(".email-validation-error").forEach(el => el.remove());
    document.querySelectorAll(".input-error").forEach(el => el.classList.remove("input-error"));
  }

  function validateEmail(input, message) {
    if (!input) return true;
    const value = input.value.trim();
    if (value === "") return true;
    if (!emailRegex.test(value)) {
      input.classList.add("input-error");
      showError(message);
      return false;
    }
    return true;
  }

  function validatePhone(input, message) {
    if (!input) return true;
    const raw = input.value.trim();
    const digits = raw.replace(/[^0-9]/g, "");
    // Deliberately country-agnostic. The browser cannot know the billing
    // country here (Shopify collects it after add-to-cart), and an earlier
    // NANP-only rule rejected ordinary UK numbers outright: "020 7946 0958"
    // and "07700 900123" are 11 digits starting with 0, so a British customer
    // simply could not buy. Australia had the mirror problem, passing as a
    // 10-digit string and then being stored as a wrong +1 number.
    //
    // So this only catches what is obviously not a phone number. The
    // authoritative parse happens server-side in normalizeToE164(), which is
    // given the order's billing country.
    const ok = digits.length >= 7 && digits.length <= 15;
    if (!ok) {
      input.classList.add("input-error");
      showError(message);
      return false;
    }
    return true;
  }

  function validateRequired(input, message) {
    if (!input) return true;
    if (input.value.trim() === "") {
      input.classList.add("input-error");
      showError(message);
      return false;
    }
    return true;
  }

  function validate() {
    removeErrors();
    const someoneElse = isSomeoneElseSelected();
    const storyteller = getVisibleStoryteller();

    const anyRadioSelected = document.querySelector('input[name="' + S.radioName + '"]:checked');
    if (!anyRadioSelected) {
      showError(S.selectWho);
      return false;
    }

    if (someoneElse) {
      if (!validateRequired(giftNameInput, S.giftNameReq)) return false;
      if (!validateRequired(giftEmailInput, S.giftEmailReq)) return false;
      if (!validateEmail(giftEmailInput, S.giftEmailBad)) return false;
      if (!validateRequired(giftDateInput, S.giftDateReq)) return false;
      if (PHONE_REQUIRED) {
        if (!validateRequired(giftPhoneInput, S.giftPhoneReq)) return false;
        if (!validatePhone(giftPhoneInput, S.giftPhoneBad)) return false;
      }
    }

    if (isMyselfSelected()) {
      if (PHONE_REQUIRED) {
        if (!validateRequired(selfPhoneInput, S.selfPhoneReq)) return false;
        if (!validatePhone(selfPhoneInput, S.selfPhoneBad)) return false;
      }
    }

    if (storyteller) {
      if (!validateRequired(storyteller.nameInput, S.storytellerNameReq)) return false;
      if (!validateRequired(storyteller.emailInput, S.storytellerEmailReq)) return false;
      if (!validateEmail(storyteller.emailInput, S.storytellerEmailBad)) return false;
      if (PHONE_REQUIRED) {
        if (!validateRequired(storyteller.phoneInput, S.storytellerPhoneReq)) return false;
        if (!validatePhone(storyteller.phoneInput, S.storytellerPhoneBad)) return false;
      }
    }

    if (someoneElse && storyteller) {
      const giftEmail = giftEmailInput && giftEmailInput.value ? giftEmailInput.value.trim().toLowerCase() : "";
      const storytellerEmail = storyteller.emailInput && storyteller.emailInput.value ? storyteller.emailInput.value.trim().toLowerCase() : "";
      if (giftEmail && storytellerEmail && giftEmail === storytellerEmail) {
        showError(S.duplicateEmail);
        return false;
      }
    }

    return true;
  }

  const productForm = document.querySelector('form[action="/cart/add"]');
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      if (!validate()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  document.addEventListener("click", function (e) {
    const target = e.target;
    const button =
      target.closest('[name="add"]') ||
      target.closest(".product-form__submit") ||
      target.closest('button[type="submit"]');
    if (button && button.closest('form[action="/cart/add"]')) {
      if (!validate()) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, true);
});
